var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationShelter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M20 72h2V60h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 72h-2V57c0-1.654-1.346-3-3-3H21c-1.654 0-3 1.346-3 3v15h-2V57c0-2.757 2.243-5 5-5h12c2.757 0 5 2.243 5 5v15",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M32 72h2V60h-2zM27 42c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM46 72h2V60h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 72h-2V57c0-1.654-1.346-3-3-3H47c-1.654 0-3 1.346-3 3v15h-2V57c0-2.757 2.243-5 5-5h12c2.757 0 5 2.243 5 5v15",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M58 72h2V60h-2zM53 42c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 36h-2c0-19.838-2.932-26-4-26s-4 6.162-4 26h-2c0-6.568.433-28 6-28s6 21.432 6 28",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 36h-2c0-15.309-5.757-26-14-26S26 20.691 26 36h-2c0-16.748 6.43-28 16-28s16 11.252 16 28",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 36h-2c0-2.206-1.794-4-4-4s-4 1.794-4 4h-2c0-3.309 2.691-6 6-6s6 2.691 6 6",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 36h-2c0-2.206-1.794-4-4-4s-4 1.794-4 4h-2c0-3.309 2.691-6 6-6s6 2.691 6 6",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 36h-2c0-2.206-1.794-4-4-4s-4 1.794-4 4h-2c0-3.309 2.691-6 6-6s6 2.691 6 6",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 36h-2c0-2.206-1.794-4-4-4s-4 1.794-4 4h-2c0-3.309 2.691-6 6-6s6 2.691 6 6",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 36h-2c0-2.206-1.794-4-4-4s-4 1.794-4 4h-2c0-3.309 2.691-6 6-6s6 2.691 6 6",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 36h-2c0-15.552-9.645-26-24-26S16 20.448 16 36h-2C14 19.514 24.691 8 40 8s26 11.514 26 28M14 40h2v-2h-2zM14 44h2v-2h-2zM64 40h2v-2h-2zM64 44h2v-2h-2z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationShelter;